const tamingRates = `

#### Taming Success Rates by Rarity
| Rarity            | Normal Rate | Scroll Rate |
|-------------------|------------|------------|
| **Basic**        | 80%        | 100%       |
| **Normal Basic** | 50%        | 75%        |
| **Special Basic**| 14%        | 21%        |
| **Normal Rare**  | 4%         | 6%         |
| **Special Rare** | 3%         | 5%         |
| **Unique**       | 2%         | 4%         |

---

### Overview of Stage Combination Rates
#### Success Rates by Stage
| Stage | Soul Catalyst | Advanced Soul Catalyst |
|-------|--------------|------------------------|
| **S 1** | 55% | 65% |
| **S 2** | 40% | 50% |
| **S 3** | 35% | 45% |
| **S 4** | 27% | 37% |
| **S 5** | 22% | 32% |

Tame wisely and best of luck! 🐉`;

export default tamingRates;
